import { ErrorsItem } from "./ErrorsItem";

export const ErrorsItemContainer = ErrorsItem;
